/* Feel Good Design System runtime - 1:1 port of the two template scripts,
   with the product page state wired to the real Shopify cart.
   Prices use per-unit rounding (2 decimals) so totals match Shopify's cart exactly. */
(function () {
  'use strict';
  var q = function (s, r) { return (r || document).querySelectorAll(s); };
  var eur = function (v) { return v.toFixed(2).replace('.', ',') + ' €'; };
  var r2 = function (v) { return Math.round(v * 100) / 100; };

  function initReveal() {
    var els = q('[data-reveal]:not(.is-observed)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in', 'is-observed'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, i = parseInt(el.getAttribute('data-reveal')) || 0;
        el.style.transitionDelay = (i * 70) + 'ms';
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { threshold: .15, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { el.classList.add('is-observed'); io.observe(el); });
    setTimeout(function () { q('[data-reveal]:not(.is-in)').forEach(function (el) { el.classList.add('is-in'); }); }, 3000);
  }

  function initAcc() {
    q('.fgx-acc:not(.is-ready)').forEach(function (acc) {
      acc.classList.add('is-ready');
      var btns = q('.fgx-acc__btn', acc);
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var open = btn.getAttribute('aria-expanded') === 'true';
          btns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); b.nextElementSibling.classList.remove('is-open'); b.querySelector('.fgx-acc__i').textContent = '+'; });
          if (!open) { btn.setAttribute('aria-expanded', 'true'); btn.nextElementSibling.classList.add('is-open'); btn.querySelector('.fgx-acc__i').textContent = '−'; }
        });
      });
    });
  }

  function initPlans() {
    q('[data-fg-plans]:not(.is-ready)').forEach(function (root) {
      root.classList.add('is-ready');
      var PLANS = JSON.parse(root.getAttribute('data-fg-plans'));
      var BOX = parseFloat(root.getAttribute('data-fg-box')) || 32.4;
      var bind = function (k, v) { q('[data-bind="' + k + '"]', root).forEach(function (el) { el.textContent = v; }); };
      function setPlan(i) {
        var p = PLANS[i], full = BOX * p.bars / 12, unit = r2(BOX / 12 * (1 - p.pct / 100)), d = unit * p.bars;
        bind('planName', p.name); bind('planBars', p.bars); bind('planPrice', eur(d)); bind('planPerBar', eur(unit));
        bind('planCompare', eur(full)); bind('planSave', eur(full - d)); bind('planPct', p.pct + '%'); bind('planShipping', p.ship);
        q('.fg-plan', root).forEach(function (el, j) {
          var on = j === i;
          el.style.borderColor = on ? '#BBAA84' : 'rgba(18,18,18,.12)';
          el.style.background = on ? '#F4EFE3' : '#fff';
          var c = el.querySelector('.fg-check'); if (c) c.style.opacity = on ? '1' : '0';
        });
        var cta = root.querySelector('[data-fg-plan-cta]');
        if (cta && p.url) cta.setAttribute('href', p.url);
      }
      q('.fg-plan', root).forEach(function (el) { el.addEventListener('click', function () { setPlan(+el.dataset.plan); }); });
      setPlan(PLANS.length > 1 ? 1 : 0);
    });
  }

  /* Cart helpers shared by both product page paths */
  function cartBody(items) {
    var drawer = document.querySelector('cart-drawer'), body = { items: items };
    if (drawer && drawer.getSectionsToRender) { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; }
    return body;
  }
  function cartAdd(items) {
    return fetch(R('/cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(cartBody(items)) })
      .then(function (r) { return r.json(); });
  }
  function cartRemoveSubscriptionLines() {
    /* One subscription box per cart: drop every line that carries a selling plan before adding the new box. */
    return fetch(R('/cart.js'), { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var keys = (cart.items || []).filter(function (it) { return it.selling_plan_allocation; }).map(function (it) { return it.key; });
      return keys.reduce(function (p, key) {
        return p.then(function () { return fetch(R('/cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) }); });
      }, Promise.resolve());
    });
  }
var FG_ROOT = (window.FG_ROOT || '/').replace(/\/$/, '');
  function R(p) { return FG_ROOT + p; }
  /* i18n: defaults are Greek; window.FG_I18N (rendered by snippets/fg-head.liquid) overrides per locale */
  var FG_T_DEFAULT = {
    error: 'Κάτι πήγε στραβά. Δοκίμασε ξανά.',
    box: 'κουτί', boxes: 'κουτιά',
    add_to_cart: 'ΠΡΟΣΘΗΚΗ ΣΤΟ ΚΑΛΑΘΙ',
    off: 'έκπτωση',
    swap: 'Αντικαθιστά μία μπάρα από άλλη γεύση',
    missing: 'ΛΕΙΠΟΥΝ {n} ΜΠΑΡΕΣ',
    excess: 'ΠΕΡΙΣΣΕΥΟΥΝ {n} ΜΠΑΡΕΣ',
    start_sub: 'ΞΕΚΙΝΑ ΣΥΝΔΡΟΜΗ',
    month: 'ΜΗΝΑ',
    hint_missing_one: 'Πρόσθεσε ακόμα {n} μπάρα από όποια γεύση θες για να γεμίσει το κουτί.',
    hint_missing_many: 'Πρόσθεσε ακόμα {n} μπάρες από όποια γεύση θες για να γεμίσει το κουτί.',
    hint_excess: 'Το {t}άρι κουτί έχει {n} μπάρες παραπάνω. Αφαίρεσε ή διάλεξε μεγαλύτερο πλάνο.',
    hint_full: 'Το κουτί είναι γεμάτο. Με το + σε άλλη γεύση αλλάζεις μία μπάρα.',
    ship_free: 'Δωρεάν μεταφορικά για το κουτί σου.',
    ship_from: 'Δωρεάν μεταφορικά από {a} ή από 24 μπάρες συνδρομής.',
    plan_unavailable: 'Το πλάνο συνδρομής δεν είναι διαθέσιμο αυτή τη στιγμή.',
    sold_out_flavour: 'Η γεύση {f} έχει εξαντληθεί στη συνδρομή. Διάλεξε κάποια από τις άλλες.'
  };
  function T(k, vars) {
    var src = (window.FG_I18N && window.FG_I18N[k] != null) ? window.FG_I18N[k] : FG_T_DEFAULT[k];
    if (src == null) return '';
    if (vars) { for (var v in vars) { src = src.split('{' + v + '}').join(vars[v]); } }
    return src;
  }
  function afterAdd(res, addedEl, errEl) {
    if (res && res.status) { if (errEl) { errEl.hidden = false; errEl.textContent = res.description || res.message || T('error'); } return false; }
    var drawer = document.querySelector('cart-drawer');
    if (addedEl) { addedEl.style.opacity = '1'; setTimeout(function () { addedEl.style.opacity = '0'; }, 2600); }
    /* Dawn keeps the "is-empty" state on the drawer element after the first add (product-form.js
       normally clears it). Without this the header and the line items stay hidden. */
    if (drawer) { drawer.classList.remove('is-empty'); var inner = drawer.querySelector('.drawer__inner'); if (inner) inner.classList.remove('is-empty'); }
    if (drawer && drawer.renderContents && res.sections) drawer.renderContents(res);
    else if (drawer && drawer.open) drawer.open();
    return true;
  }

  function initPdp() {
    var root = document.querySelector('[data-fg-pdp]:not(.is-ready)');
    if (!root) return;
    root.classList.add('is-ready');
    var D = JSON.parse(document.getElementById('fg-pdp-data').textContent);
    var FL = D.flavors, BOX = D.box, FREE = D.free, SEL = D.sel || 0, F = FL[SEL];
    var PCT_BY_BARS = { 12: 12, 24: 15, 48: 20 };
    /* Initial plan: ?plan=12|24|48 in the URL wins, then data-fg-plan on the root, then 12.
       Prefill (data-fg-prefill): "balanced" fills the box with the same number of bars of every
       flavour (12 → 2 each, 24 → 4 each, 48 → 8 each, decision George 13/10/2026) so the customer
       can go straight to checkout; a number prefills that many bars of the current flavour; 0 leaves it empty. */
    var urlParams = new URLSearchParams(window.location.search);
    var urlPlan = parseInt(urlParams.get('plan'), 10);
    var initPlan = [12, 24, 48].indexOf(urlPlan) >= 0 ? urlPlan : (parseInt(root.getAttribute('data-fg-plan'), 10) || 12);
    var prefillAttr = root.hasAttribute('data-fg-prefill') ? root.getAttribute('data-fg-prefill') : '12';
    var balancedDefault = prefillAttr === 'balanced';
    var prefill = balancedDefault ? 0 : (parseInt(prefillAttr, 10) || 0);
    /* S.touched: the customer changed a flavour quantity by hand. Until then a plan change refills the
       box balanced for the new size; after that their choices are kept and only the counter changes. */
    var S = { shot: 0, boxes: 1, target: initPlan, qty: {}, touched: false };
    /* Availability (v3.9, 13/10/2026): F.available / F.qty for the box of this page, FL[i].subAvailable for the
       single-bar subscription SKUs. A sold-out single is skipped by balanced() and its row stays locked. */
    function subOk(i) { return !!(FL[i].subVariantId && FL[i].subAvailable !== false); }
    var maxBoxes = (typeof F.qty === 'number' && F.qty > 0) ? Math.min(20, F.qty) : 20;
    function balanced(target) {
      var idx = [], i, out = {};
      for (i = 0; i < FL.length; i++) if (subOk(i)) idx.push(i);
      if (!idx.length) return out;
      var base = Math.floor(target / idx.length), rest = target - base * idx.length;
      for (i = 0; i < idx.length; i++) { var n = base + (i < rest ? 1 : 0); if (n) out[idx[i]] = n; }
      return out;
    }
    if (balancedDefault) S.qty = balanced(initPlan);
    else if (prefill) S.qty[SEL] = Math.min(prefill, initPlan);
    var bind = function (k, v) { q('[data-bind="' + k + '"]', root).forEach(function (el) { el.textContent = v; }); };

    /* Gallery slots (order set in Shopify, 03/10/2026): 0 bar front, 1 bar back (nutrition table and barcode),
       2 box, 3 lifestyle photo (falls back to the optional section photo), 4 all flavours (optional section photo).
       Each thumb carries its slot in data-shot, so a missing slot never shifts the others. */
    function shots() { return [
      { src: F.bar, fit: 'contain', pad: '12%' }, { src: F.back, fit: 'contain', pad: '12%' },
      { src: F.box, fit: 'contain', pad: '8%' },
      { src: F.life || D.shotTexture, fit: 'cover', pad: '0' }, { src: D.shotAll, fit: 'cover', pad: '0' } ]; }

    /* Selling plan for a bar count: exact match on bars, then on discount percentage. */
    function planFor(bars) {
      var pct = PCT_BY_BARS[bars], i, j, plans;
      for (j = 0; j < FL.length; j++) {
        plans = FL[j].plans || [];
        for (i = 0; i < plans.length; i++) if (plans[i].bars === bars) return plans[i];
        if (pct) for (i = 0; i < plans.length; i++) if (+plans[i].pct === pct) return plans[i];
      }
      return null;
    }
    function pctFor(bars) { var p = planFor(bars); return p ? p.pct : (PCT_BY_BARS[bars] || 0); }

    function render() {
      var selbar = document.getElementById('fg-selbar'); if (selbar && selbar.getAttribute('src') !== F.bar) selbar.src = F.bar;
      var sh = shots();
      q('.fg-thumb', root).forEach(function (t) {
        var k = parseInt(t.dataset.shot, 10) || 0;
        var im = t.querySelector('img'); if (im && sh[k] && sh[k].src && im.getAttribute('src') !== sh[k].src) im.src = sh[k].src;
        t.style.borderColor = k === S.shot ? '#121212' : 'rgba(18,18,18,.10)';
        t.style.borderWidth = k === S.shot ? '2px' : '1px';
      });
      var img = document.getElementById('fg-shot');
      if (img && sh[S.shot] && sh[S.shot].src) {
        if (img.getAttribute('src') !== sh[S.shot].src) { img.src = sh[S.shot].src; img.style.animation = 'none'; void img.offsetWidth; img.style.animation = ''; }
        img.style.objectFit = sh[S.shot].fit; img.style.padding = sh[S.shot].pad;
      }

      /* Path 1: this box */
      var once = r2(BOX * S.boxes);
      bind('boxes', S.boxes); bind('boxesLabel', S.boxes === 1 ? T('box') : T('boxes'));      bind('onceTotal', eur(once)); bind('oncePerBar', eur(r2(BOX / 12)));
      bind('onceCta', T('add_to_cart') + ' · ' + eur(once));
      var incBox = document.getElementById('fg-box-inc'), maxNote = document.getElementById('fg-box-max-note');
      if (incBox) { var atMax = S.boxes >= maxBoxes; incBox.disabled = atMax; incBox.style.opacity = atMax ? '.3' : '1'; incBox.style.cursor = atMax ? 'not-allowed' : 'pointer'; }
      if (maxNote) maxNote.hidden = S.boxes < maxBoxes;

      /* Path 2: subscription box */
      var pct = pctFor(S.target), unit = r2(BOX / 12 * (1 - pct / 100)), count = 0, k;
      for (k in S.qty) count += S.qty[k];
      var subTotal = r2(unit * S.target), missing = S.target - count;
      bind('subTarget', S.target); bind('subCount', count); bind('subPerBar', eur(unit)); bind('subTotal', eur(subTotal));
      bind('subDiscountLabel', pct + '% ' + T('off'));
      var bar = document.getElementById('fg-sub-bar'); if (bar) bar.style.width = Math.min(100, count / S.target * 100) + '%';
      q('.fg-plan-btn', root).forEach(function (b) {
        var on = +b.dataset.bars === S.target;
        b.style.borderColor = on ? '#121212' : 'rgba(18,18,18,.16)'; b.style.borderWidth = on ? '2px' : '1px';
        b.style.background = on ? '#fff' : 'rgba(255,255,255,.6)';
        b.style.boxShadow = on ? '0 6px 18px rgba(18,18,18,.08)' : 'none';
      });
      q('.fg-qty', root).forEach(function (e) { e.textContent = S.qty[+e.dataset.f] || 0; });
      q('.fg-row', root).forEach(function (r, i) { r.style.borderColor = S.qty[i] ? 'rgba(18,18,18,.4)' : 'rgba(18,18,18,.10)'; });
      q('.fg-inc', root).forEach(function (b) {
        var i = +b.dataset.f, canSwap = false, j;
        if (!subOk(i)) { b.disabled = true; b.style.opacity = '.3'; b.title = ''; return; }
        if (missing <= 0) { for (j in S.qty) { if (+j !== i && S.qty[j] > 0) { canSwap = true; break; } } }
        var off = missing <= 0 && !canSwap;
        b.disabled = off; b.style.opacity = off ? '.3' : '1';
        b.title = (missing <= 0 && canSwap) ? T('swap') : '';
      });
      var ctaSub = document.getElementById('fg-cta-sub'), hint = document.getElementById('fg-sub-hint');
      if (missing > 0) { bind('subCta', T('missing', { n: missing })); }
      else if (missing < 0) { bind('subCta', T('excess', { n: -missing })); }
      else { bind('subCta', T('start_sub') + ' · ' + eur(subTotal) + ' / ' + T('month')); }
      if (ctaSub) { ctaSub.style.opacity = missing === 0 ? '1' : '.45'; ctaSub.style.pointerEvents = missing === 0 ? '' : 'none'; }
      if (hint && !hint.dataset.err) {
        if (missing > 0) { hint.hidden = false; hint.textContent = T(missing === 1 ? 'hint_missing_one' : 'hint_missing_many', { n: missing }); }
        else if (missing < 0) { hint.hidden = false; hint.textContent = T('hint_excess', { t: S.target, n: -missing }); }
        else { hint.hidden = false; hint.style.color = '#6E6A5E'; hint.textContent = T('hint_full'); }
        if (missing !== 0) hint.style.color = '#B3382C';
      }
      bind('shippingLine', (once >= FREE) ? T('ship_free') : T('ship_from', { a: eur(FREE) }));
    }

    q('.fg-thumb', root).forEach(function (t) { t.addEventListener('click', function () { S.shot = parseInt(t.dataset.shot, 10) || 0; render(); }); });
    var dec = document.getElementById('fg-box-dec'), inc = document.getElementById('fg-box-inc');
    if (dec) dec.addEventListener('click', function () { S.boxes = Math.max(1, S.boxes - 1); render(); });
    if (inc) inc.addEventListener('click', function () { S.boxes = Math.min(maxBoxes, S.boxes + 1); render(); });
    /* Sold-out flavour row in the widget: a tap explains why it cannot be added, then the normal hint returns. */
    q('.fg-row--out', root).forEach(function (row) { row.addEventListener('click', function () {
      var i = +row.dataset.f, hint = document.getElementById('fg-sub-hint');
      if (!hint || hint.dataset.err) return;
      hint.hidden = false; hint.style.color = '#B3382C'; hint.textContent = T('sold_out_flavour', { f: (FL[i] && FL[i].short) || '' });
      clearTimeout(row._t); row._t = setTimeout(render, 4000);
    }); });
    q('.fg-plan-btn', root).forEach(function (b) { b.addEventListener('click', function () {
      S.target = +b.dataset.bars;
      if (balancedDefault && !S.touched) S.qty = balanced(S.target);
      render();
    }); });
    q('.fg-inc', root).forEach(function (b) { b.addEventListener('click', function () {
      var i = +b.dataset.f, count = 0, k;
      if (!subOk(i)) return;
      S.touched = true;
      for (k in S.qty) count += S.qty[k];
      if (count >= S.target) {
        /* Box is full: take one bar from the other flavour that has the most, so "+" always does something. */
        var from = -1, max = 0;
        for (k in S.qty) { if (+k !== i && S.qty[k] > max) { max = S.qty[k]; from = +k; } }
        if (from < 0) return;
        S.qty[from] -= 1; if (!S.qty[from]) delete S.qty[from];
      }
      S.qty[i] = (S.qty[i] || 0) + 1; render();
    }); });
    q('.fg-dec', root).forEach(function (b) { b.addEventListener('click', function () { var i = +b.dataset.f; S.touched = true; S.qty[i] = Math.max(0, (S.qty[i] || 0) - 1); if (!S.qty[i]) delete S.qty[i]; render(); }); });

    var nut = document.getElementById('fg-nut');
    if (nut) nut.addEventListener('click', function () {
      var open = nut.getAttribute('aria-expanded') === 'true';
      nut.setAttribute('aria-expanded', String(!open));
      document.getElementById('fg-nut-p').style.maxHeight = open ? '0' : '900px';
      document.getElementById('fg-nut-i').style.transform = open ? 'none' : 'rotate(180deg)';
    });

    /* Path 1 add to cart: the box variant of this product */
    var ctaOnce = document.getElementById('fg-cta-once');
    if (ctaOnce) ctaOnce.addEventListener('click', function (e) {
      e.preventDefault();
      ctaOnce.style.opacity = '.6';
      cartAdd([{ id: F.variantId, quantity: S.boxes }])
        .then(function (res) { afterAdd(res, document.getElementById('fg-added-once'), null); })
        .catch(function () { window.location.href = R('/cart'); })
        .finally(function () { ctaOnce.style.opacity = '1'; });
    });

    /* Path 2 add to cart: single bars with the selling plan of the chosen box */
    var ctaSub = document.getElementById('fg-cta-sub');
    if (ctaSub) ctaSub.addEventListener('click', function (e) {
      e.preventDefault();
      var count = 0, k; for (k in S.qty) count += S.qty[k];
      if (count !== S.target) return;
      var plan = planFor(S.target), hint = document.getElementById('fg-sub-hint');
      if (!plan) { hint.hidden = false; hint.dataset.err = '1'; hint.textContent = T('plan_unavailable'); return; }
      var items = [];
      for (k in S.qty) { var f = FL[+k]; if (f.subVariantId && S.qty[k]) items.push({ id: f.subVariantId, quantity: S.qty[k], selling_plan: plan.id }); }
      ctaSub.style.opacity = '.6';
      cartRemoveSubscriptionLines()
        .then(function () { return cartAdd(items); })
        .then(function (res) { afterAdd(res, document.getElementById('fg-added-sub'), hint); })
        .catch(function () { window.location.href = R('/cart'); })
        .finally(function () { ctaSub.style.opacity = '1'; });
    });
    render();

    /* Prefill from the cart: .../pages/subscribe?plan=24&prefill=cart keeps the flavours the
       customer already picked in a subscription box that is still in the cart, so changing plan
       from the cart message does not wipe their choices. Bars beyond the new plan's size are
       dropped, never added, and a failed fetch simply leaves the default fill in place.
       Flavours taken from the cart count as the customer's own choices (S.touched). */
    if (urlParams.get('prefill') === 'cart') {
      fetch(R('/cart.js'), { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var byVariant = {}, i;
          for (i = 0; i < FL.length; i++) if (FL[i].subVariantId) byVariant[String(FL[i].subVariantId)] = i;
          var picked = {}, total = 0;
          (cart.items || []).forEach(function (it) {
            if (!it.selling_plan_allocation) return;
            var idx = byVariant[String(it.variant_id)];
            if (idx === undefined || !subOk(idx)) return;
            picked[idx] = (picked[idx] || 0) + it.quantity;
            total += it.quantity;
          });
          if (!total) return;
          if (total > S.target) {
            var keep = S.target, trimmed = {};
            Object.keys(picked).forEach(function (k) {
              if (keep <= 0) return;
              var take = Math.min(picked[k], keep);
              trimmed[k] = take; keep -= take;
            });
            picked = trimmed;
          }
          S.qty = picked;
          S.touched = true;
          render();
        })
        .catch(function () {});
    }

    /* Deep link from the homepage subscription section: /products/...?plan=24#fg-sub */
    if (window.location.hash === '#fg-sub') setTimeout(function () { var el = document.getElementById('fg-sub'); if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 88, behavior: 'instant' }); }, 600);
  }

  function boot() { initReveal(); initAcc(); initPlans(); initPdp(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
